import { render, staticRenderFns } from "./SelecionaMensagem.vue?vue&type=template&id=a786b04a"
import script from "./SelecionaMensagem.vue?vue&type=script&lang=js"
export * from "./SelecionaMensagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports